module.exports = __webpack_public_path__ + "img/Vector3.4428dd02.svg";